/**
 * Names for the ids an `org` question's filters carry — projects and agents
 * (#765 Ф3). The `/assistant` page provides them from the same options its
 * filter controls use; elsewhere (the drawer reading a thread asked from the
 * page) there is no provider, and a filter line names the kind of filter
 * without the name rather than reading options in a layout that may not have
 * them (the Bitrix24 iframe).
 */

import { createContext, useContext } from 'react';

export interface AssistantFilterNames {
  projects: ReadonlyMap<string, string>;
  agents: ReadonlyMap<string, string>;
}

export const AssistantFilterNamesContext = createContext<AssistantFilterNames | null>(
  null
);

export function useAssistantFilterNames(): AssistantFilterNames | null {
  return useContext(AssistantFilterNamesContext);
}
